import { Pipe, PipeTransform } from '@angular/core';
import { DepartmentEstimate } from '@interfaces/DepartmentEstimate';

@Pipe({
  name: 'expenseBillableFinal'
})
export class ExpenseBillableFinalPipe implements PipeTransform {
  public transform(departmentEstimate: DepartmentEstimate): number {
    let total = 0;

    for (const line of departmentEstimate.estimateLines) {
      if (line.expenseLine) {
        if (line.expenseLine.billableFinal !== null) {
          total += line.expenseLine.billableFinal;
        } else {
          total += line.expenseLine.amountBillable;
        }
      }
    }
    return total;
  }
}
